<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-container">
                <!-- Menu header start -->
                <Navbar1 />
                <!-- Menu header end -->
                <div class="pcoded-main-container">

                    <Menu />
                    <!-- Sidebar inner chat end-->
                    <div class="pcoded-wrapper">
                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">

                                <!-- Main-body start -->
                                <div class="main-body">
                                    <div class="page-wrapper">
                                        <!-- Page-header start -->
                                        <div class="page-header card m-t-40">
                                            <div class="row align-items-end">
                                                <div class="col-lg-8">
                                                    <div class="page-header-title">
                                                        <i class="icofont icofont-restaurant-menu bg-c-pink"></i>
                                                        <div class="d-inline">
                                                            <h4>Stage 3</h4>
                                                            <span>Interview: View interview information, view and accept offers.</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Page-header end -->
                                        <!-- Page body start -->
                                        <div class="page-body">
                                            
                                            <div class="card" style="min-height: 500px;">
                                                <!-- <div class="card-header">
                                                    <h5>Interview</h5>
                                                    <div class="card-header-right">    
                                                        <ul class="list-unstyled card-option">        
                                                            <li><i class="icofont icofont-simple-left "></i></li>        
                                                            <li><i class="icofont icofont-maximize full-card"></i></li>        
                                                            <li><i class="icofont icofont-minus minimize-card"></i></li>        
                                                            <li><i class="icofont icofont-refresh reload-card"></i></li>        
                                                            <li><i class="icofont icofont-error close-card"></i></li>    
                                                        </ul>
                                                    </div>
                                                </div> -->
                                                <div class="card-block tab-icon">
                                                    <!-- Row start -->
                                                    <div class="row">
                                                        <div class="col-lg-12 col-xl-12">
                                                            <!-- <h6 class="sub-title">Tab With Icon</h6> -->
                                                            <div class="sub-title">Inteview</div>
                                                            <!-- Nav tabs -->
                                                            <ul class="nav nav-tabs md-tabs " role="tablist">
                                                                <li class="nav-item">
                                                                    <a class="nav-link active" data-toggle="tab" href="#interview_information" role="tab"><i class="icofont icofont-home"></i>Interview Information</a>
                                                                    <div class="slide"></div>
                                                                </li>
                                                                <li class="nav-item">
                                                                    <a class="nav-link" data-toggle="tab" href="#offer" role="tab" v-on:click="getOfferLetter"><i class="icofont icofont-ui-user "></i>Offer</a>
                                                                    <div class="slide"></div>
                                                                </li>
                                                            </ul>
                                                            <!-- Tab panes -->
                                                            <div class="tab-content card-block">

                                                                <div class="tab-pane active" id="interview_information" role="tabpanel">
                                                                    <div class="card-block user-detail-card">
                                                                        <div class="row">
                                                                            <div class="col-sm-8 user-detail">
                                                                                <div class="row">
                                                                                    <div class="col-sm-5">
                                                                                        <h6 class="f-w-400 m-b-30"><i class="icofont icofont-map-pins"></i>Location :</h6>
                                                                                    </div>
                                                                                    <div class="col-sm-7">
                                                                                        <h6 class="m-b-30">{{InterviewInformation.location}}</h6>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="row">
                                                                                    <div class="col-sm-5">
                                                                                        <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-calendar"></i>Date :</h6>
                                                                                    </div>
                                                                                    <div class="col-sm-7">
                                                                                        <h6 class="m-b-30">{{InterviewInformation.date}}</h6>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="row">
                                                                                    <div class="col-sm-5">
                                                                                        <h6 class="f-w-400 m-b-30"><i class="icofont icofont-clock-time"></i>Time :</h6>
                                                                                    </div>
                                                                                    <div class="col-sm-7">
                                                                                        <h6 class="m-b-30">{{InterviewInformation.time}}</h6>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="row">
                                                                                    <div class="col-sm-5">
                                                                                        <h6 class="f-w-400 m-b-30"><i class="icofont icofont-list"></i>Requirement :</h6>
                                                                                    </div>
                                                                                    <div class="col-sm-7">
                                                                                        <h6 class="m-b-30">{{removeTags(InterviewInformation.requirements)}}</h6>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                <div class="tab-pane" id="offer" role="tabpanel">
                                                                    <div class="card">
                                                                        <div class="card-block">
                                                                            <h4 class="sub-title">OFFER LETTER</h4>
                                                                            <div v-html="offer_letter"></div>
                                                                        </div>
                                                                        <div class="card-footer">
                                                                            <div class="row">
                                                                                <div class="col-sm-12 text-right" v-show="!responded">
                                                                                    <button type="button" class="btn btn-success waves-effect btn-md waves-light m-r-10 m-t-10 m-b-10" v-on:click="respondToOffer('accept')">
                                                                                        Accept
                                                                                    </button>
                                                                                    <button type="button" class="btn btn-danger waves-effect btn-md waves-light m-r-10 m-t-10 m-b-10" data-toggle="modal" data-target="#declineOfferLetter">
                                                                                        Decine
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- Row end -->
                                                </div>
                                            </div>

                                        </div>
                                        <!-- Page body end -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="declineOfferLetter" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Decline offer.</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="respondToOffer('decline')">
                            <div class="form-group">
                                <label>Reason for Decline: </label>
                                <textarea class="form-control" placeholder="Reason..." v-model="offer_response.reasonfordecline" height="400px" required="required" minlength="50"></textarea>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-md btn-danger form-control">Decline</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<style scoped>
    @import '../assets/css/dashboard.css'

    .applicant{
        margin-top: 50px;
    }
    .applicant .info-block{
        display: block;
        padding: 9px;
    }
    .applicant .label{
        font-size: 15px;
        /*font-weight: bold;*/
    }
    .applicant .detail{
        font-size: 16px;
        font-weight: bold;
        padding-left: 20px;
    }
    tr td:nth-child(1){
        font-weight: bold;
    }
    .do-nothing{
        pointer-events: none;
        cursor: not-allowed;
    }
    .icons-alert:before{
        top: 0px !important;
    }
</style>
<script>
import Navbar1 from '../components/Navbar1.vue'
import Menu from '../components/Menu.vue'

export default{
    name: 'Stage3',

    data(){
        return{
            InterviewInformation: {
                applicant_id: "",
                created_at: "",
                date: "",
                deleted_at: "",
                id: "",
                joblisting_id: "",
                location: "",
                process_id: "",
                requirements: "",
                time: "",
                updated_at: ""
            },
            offer_letter: "<div style='margin:0 auto;width:100px;'><img src='https://www.drupal.org/files/issues/throbber_12.gif' style='width:100%;'/></div>",

            offer_response:{
                reasonfordecline: ""
            },

            responded: true
        }
    },

    components:{
        Navbar1,
        Menu
    },

    mounted(){
        var user_data = this.$store.getters.user_data.data

        this.applicant_id = user_data.id

        this.getInterviewInformation(user_data.id)
    },
    methods: {

        removeTags: function(str) {
            if ((str===null) || (str===''))
                return false;
            else
                str = str.toString();
                
            // Regular expression to identify HTML tags in 
            // the input string. Replacing the identified 
            // HTML tag with a null string.
            return str.replace( /(<([^>]+)>)/ig, '');
        },
            
       getInterviewInformation: function(id){

            var ii = {
                what: 'InterviewInformation',
                id: id
            }

            this.$socket.makeGetRequest(ii)
                .then((response)=>{
                    if(response.type == 'InterviewInformation'){
                        this.InterviewInformation = response.data[0]
                    }
                })
                .catch((e)=>{
                    console.log(e)
                })
        },

        getOfferLetter: function(){

            var ii = {
                what: 'GetOfferLetter',
                params: {
                    applicant_id: this.applicant_id
                }
            }

            this.$socket.makeGetRequest(ii)
                .then((response)=>{
                    if(response.type == 'GetOfferLetter'){
                        if(response.data[0] !== undefined){
                            this.offer_letter = response.data[0].template_body
                            this.responded = false
                        } else {
                            this.offer_letter = '<div class="alert alert-warning icons-alert">Sorry, no offer has been made yet.</div>'
                            this.responded = true
                        }
                    }
                })
                .catch((e)=>{
                    this.offer_letter = e.message
                    console.log(e)
                })
        },

        respondToOffer: function(res){

            this.offer_response.decision = (res == 'accept') ? 1 : 0

            this.offer_response.applicant_id = this.applicant_id

            var c = confirm("Do you want to " +res+ " this offer?")

            if(c){
                var off_res = {
                    what: 'RespondToOffer',
                    data: this.offer_response
                }

                this.$socket.makePostRequest(off_res)
                    .then((response)=>{
                        if(response.type == 'RespondToOffer'){
                            this.$swal.fire('Success', response.data.message, 'success')
                        }
                    })
                    .catch((e)=>{
                        console.log(e)
                    })
            }

                
        }

    },
    computed: {
        
    }
}
</script>
